import { useCallback, useRef } from "react";
var initialRect = {
    prevContainerRight: -1,
    prevTabWidth: -1,
};
export default (function (ref, target, callback, deps) {
    var prevValuesRef = useRef(initialRect);
    return useCallback(function () {
        if (!ref.current || !target.current.length)
            return;
        var container = ref.current;
        var containerRight = container.getBoundingClientRect().right;
        var lastTab = target.current[target.current.length - 1];
        var _a = lastTab.getBoundingClientRect(), tabRight = _a.right, tabWidth = _a.width;
        var _b = prevValuesRef.current, prevContainerRight = _b.prevContainerRight, prevTabWidth = _b.prevTabWidth;
        if (prevContainerRight === containerRight && prevTabWidth === tabWidth)
            return;
        prevValuesRef.current = {
            prevContainerRight: containerRight,
            prevTabWidth: tabWidth,
        };
        if (tabRight >= containerRight)
            return callback(true);
        if (tabRight + tabWidth < containerRight)
            return callback(false);
    }, deps);
});
